export const vi = {
  common: {
    save: 'Lưu',
    cancel: 'Huỷ',
    edit: 'Sửa',
    delete: 'Xoá',
    retry: 'Thử lại',
    saved: 'Đã lưu',
    none: '—',
    loadError: 'Không tải được dữ liệu',
    search: 'Tìm kiếm…',
    columns: 'Cột',
    export: 'Xuất CSV',
    selected: 'Đã chọn {{count}}',
  },
  types: { company: 'Công ty', division: 'Khối', department: 'Phòng ban', team: 'Nhóm' },
  statuses: { active: 'Đang làm việc', on_leave: 'Tạm nghỉ', terminated: 'Đã nghỉ việc' },
  chart: {
    title: 'Sơ đồ tổ chức',
    description: 'Cơ cấu công ty, khối, phòng ban và nhóm.',
    addUnit: 'Thêm đơn vị',
    addChild: 'Thêm đơn vị con',
    move: 'Di chuyển',
    moveTo: 'Chuyển vào đơn vị',
    head: 'Trưởng đơn vị',
    code: 'Mã',
    name: 'Tên đơn vị',
    type: 'Loại',
    parent: 'Đơn vị cha',
    order: 'Thứ tự',
    members: 'Thành viên',
    noMembers: 'Chưa có nhân viên',
    inactive: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
    deactivate: 'Ngừng hoạt động',
    employees_one: '{{count}} nhân viên',
    employees_other: '{{count}} nhân viên',
    deleteConfirm: 'Xoá đơn vị {{name}}?',
    expandAll: 'Mở rộng tất cả',
    collapseAll: 'Thu gọn tất cả',
  },
  employees: {
    title: 'Nhân viên',
    description: 'Danh bạ và hồ sơ nhân viên.',
    add: 'Thêm nhân viên',
    fullName: 'Họ tên',
    code: 'Mã nhân viên',
    email: 'Email công việc',
    phone: 'Điện thoại',
    hireDate: 'Ngày vào làm',
    status: 'Trạng thái',
    unit: 'Đơn vị',
    jobTitle: 'Chức danh',
    manager: 'Quản lý trực tiếp',
    allUnits: 'Tất cả đơn vị',
    includeSubunits: 'Gồm đơn vị con',
    allStatuses: 'Đang làm việc & tạm nghỉ',
    empty: 'Không có nhân viên phù hợp',
    noAccount: 'Chưa có tài khoản Portal',
    assignments: 'Quá trình công tác',
    assign: 'Phân công',
    assignHint: 'Phân công chính mới sẽ kết thúc phân công chính hiện tại.',
    primary: 'Chính',
    concurrent: 'Kiêm nhiệm',
    isPrimary: 'Phân công chính',
    startDate: 'Từ ngày',
    endAssignment: 'Kết thúc',
    current: 'hiện tại',
    directReports: 'Nhân viên trực tiếp',
    profile: 'Hồ sơ',
    myProfile: 'Hồ sơ của tôi',
  },
  jobTitles: {
    title: 'Chức danh',
    description: 'Danh mục chức danh dùng khi phân công nhân viên.',
    add: 'Thêm chức danh',
    name: 'Tên chức danh',
    code: 'Mã',
    level: 'Cấp bậc',
    levelHint: '1 = cao nhất; dùng để sắp xếp.',
    employees: 'Đang đảm nhiệm',
    active: 'Đang dùng',
    empty: 'Chưa có chức danh',
  },
  errors: {
    'core-organization': {
      cycle: 'Không thể chuyển đơn vị vào chính nó hoặc đơn vị con của nó.',
      root_required: 'Không thể thực hiện với đơn vị gốc (công ty).',
      unit_has_children: 'Hãy di chuyển hoặc xoá các đơn vị con trước.',
      unit_in_use: 'Đơn vị đã/đang có nhân viên; hãy chuyển sang "Ngừng hoạt động" thay vì xoá.',
      duplicate: 'Mã hoặc tên đã tồn tại.',
      employee_terminated: 'Không thể phân công nhân viên đã nghỉ việc.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    retry: 'Retry',
    saved: 'Saved',
    none: '—',
    loadError: 'Could not load data',
    search: 'Search…',
    columns: 'Columns',
    export: 'Export CSV',
    selected: '{{count}} selected',
  },
  types: { company: 'Company', division: 'Division', department: 'Department', team: 'Team' },
  statuses: { active: 'Active', on_leave: 'On leave', terminated: 'Terminated' },
  chart: {
    title: 'Org chart',
    description: 'Company, divisions, departments and teams.',
    addUnit: 'Add unit',
    addChild: 'Add sub-unit',
    move: 'Move',
    moveTo: 'Move under',
    head: 'Head',
    code: 'Code',
    name: 'Unit name',
    type: 'Type',
    parent: 'Parent unit',
    order: 'Order',
    members: 'Members',
    noMembers: 'No employees yet',
    inactive: 'Inactive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    employees_one: '{{count}} employee',
    employees_other: '{{count}} employees',
    deleteConfirm: 'Delete unit {{name}}?',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
  },
  employees: {
    title: 'Employees',
    description: 'Directory and employee profiles.',
    add: 'Add employee',
    fullName: 'Full name',
    code: 'Employee code',
    email: 'Work e-mail',
    phone: 'Phone',
    hireDate: 'Hire date',
    status: 'Status',
    unit: 'Unit',
    jobTitle: 'Job title',
    manager: 'Manager',
    allUnits: 'All units',
    includeSubunits: 'Include sub-units',
    allStatuses: 'Active & on leave',
    empty: 'No matching employees',
    noAccount: 'No Portal account',
    assignments: 'Assignment history',
    assign: 'Assign',
    assignHint: 'A new primary assignment ends the current primary one.',
    primary: 'Primary',
    concurrent: 'Concurrent',
    isPrimary: 'Primary assignment',
    startDate: 'From',
    endAssignment: 'End',
    current: 'present',
    directReports: 'Direct reports',
    profile: 'Profile',
    myProfile: 'My profile',
  },
  jobTitles: {
    title: 'Job titles',
    description: 'Titles used when assigning employees.',
    add: 'Add job title',
    name: 'Title',
    code: 'Code',
    level: 'Level',
    levelHint: '1 = most senior; used for sorting.',
    employees: 'Held by',
    active: 'In use',
    empty: 'No job titles yet',
  },
  errors: {
    'core-organization': {
      cycle: 'A unit cannot be moved under itself or its sub-units.',
      root_required: 'Not possible for the company (root) unit.',
      unit_has_children: 'Move or delete the sub-units first.',
      unit_in_use: 'Employees are or were in this unit; deactivate it instead of deleting.',
      duplicate: 'The code or name already exists.',
      employee_terminated: 'Terminated employees cannot be assigned.',
    },
    generic: 'The action failed. Please try again.',
  },
};
